import React from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';

import Utils from '../../../Services/Utils';

import InputText from '../Text';
import withShallowComparison from '../../Common/withShallowComparisonUpdate';
import InputWrapper from '../WrapperInput';
import Icon from "../../Common/Icon";
import {ReactComponent as TimeIcon} from "../../../../img/icon-time.svg";

class InputTime extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      mask: this.props.mask || '99:99'
    };
  }

  componentDidMount() {
    this.initValidate();
  }

  componentDidUpdate() {
    this.initValidate();
  }

  initValidate = () => {
    const { value, onError, error } = this.props;
    const newError = this.validate(value);
    if (onError && !Utils.equals(newError, error)) onError(newError);
  }

  validate = (value) => {
    const { required, validators } = this.props;
    if (required && Utils.isNull(value)) return 'This field is required.';
    for (const validator of validators || []) {
      if (validator(value)) return validator(value);
    }
    return '';
  };

  formatTime = (value) => {
    const date = new Date();
    const arrayValue = value.split(':');
    return date.setHours(arrayValue[0], arrayValue[1]);
  };

  handleChange = (e) => {
    const { onChange, onError, error, formatTime } = this.props;
    const formatT = formatTime || 'H:i';
    const value = e && e.target ? e.target.value : e;
    if (onChange) onChange(value ? value.dateFormat(formatT) : null);
    const newError = this.validate(value);
    if (onError && !Utils.equals(newError, error)) onError(newError);
  };

  render() {
    const {
      className,
      label,
      labelhtml,
      error,
      disabled,
      required,
      value,
      formatTime,
    } = this.props;

    const WrapperProps = {
      className,
      label,
      labelhtml,
      error,
      required
    };

    const formatT = formatTime || 'HH:mm';
    const valueDate = value ? this.formatTime(value) : undefined;
    const withPortal = this.props.withPortal || false;
    const popperPlacement = this.props.popperPlacement || 'bottom-start';

    return (
      <InputWrapper { ...WrapperProps }>
        <DatePicker
          customInput={
            <InputText
               value={ value }
               required={ required }
               disabled={ disabled }
               disablechange='true'
               debounce={ 0 }
               mask={ this.state.mask }
            />
          }
          selected={ valueDate }
          onChange={ this.handleChange }
          disabled={ disabled }
          timeFormat={ formatT }
          dateFormat={ formatT }
          popperPlacement={ popperPlacement }
          showTimeSelect
          showTimeSelectOnly
          timeIntervals={15}
          timeCaption='Time'
          className='InputTime'
          withPortal={ withPortal }
        />
        <Icon width='15' height='15' color='secondaryColor' position='Right'>
          <TimeIcon alt='icon-time'/>
        </Icon>
      </InputWrapper>
    );
  }
}

InputTime.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  error: PropTypes.string,
  formatTime: PropTypes.string,
  placeholder: PropTypes.string,
  popperPlacement: PropTypes.string,
  withPortal: PropTypes.bool,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  onChange: PropTypes.func,
  onError: PropTypes.func,
};

export default withShallowComparison(InputTime, ['onChange', 'onError']);